// extracted by mini-css-extract-plugin
export default {"scrollToTopButton":"menuTab_scrollToTopButton__JN-Hx","pulse":"menuTab_pulse__kAsbh"};